module.exports = __webpack_public_path__ + "img/course6.506f4b9b.png";